export default "__VITE_ASSET__BmAOJzDV__"